export function getBrowserName() {
    if (navigator.brave && typeof navigator.brave.isBrave === 'function') {
        return 'Brave';
    }

    const userAgent = navigator.userAgent;

    switch (true) {
        case /Firefox/i.test(userAgent):
            return "Firefox";
        case /Edg/i.test(userAgent):
            return "Edge";
        case /Chrome/i.test(userAgent):
            return "Chrome";
        case /Safari/i.test(userAgent):
            return "Safari";
        default:
            return "Browser";
    }
} 